import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { apiSlice } from "../api/apiSlice";
import countriesReducer from "./countriesSlice";
import subjectsReducer from "./subjectsSlice";
import mentorshipReducer from "./mentorshipSlice";

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    countries: countriesReducer,
    subjects: subjectsReducer,
    mentorship: mentorshipReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

setupListeners(store.dispatch);
